"use client";
import React from "react";
import { Sun } from "lucide-react";
import { projectData } from "../data/projectData";
import { motion } from "framer-motion";
import Image from "next/image"; // Import Next.js Image component for optimized images

const Projects = () => {
  return (
    <div className="flex flex-col gap-4 bg-quad lg:justify-evenly py-[4rem] px-[1.5rem] sm:px-[3rem] lg:px-[6rem]">
      <div className="flex flex-col gap-3 mb-4">
        <div className="text-pri text-desc-size2 flex items-center gap-2">
          <Sun size={20} />
          <span>{projectData.title.mainTitle}</span>
        </div>
        <div className="text-text1 text-title-size3 lg:text-title-size2 md:w-[60vw] leading-[1]">
          {projectData.title.heading}
        </div>
      </div>
      <div className="flex flex-col gap-[2vw] w-full">
        <div className="flex flex-col sm:flex-row gap-[2vw]">
          {projectData.projects.slice(0, 2).map((project, index) => (
            <motion.div
              key={index}
              initial={{ scale: 0.8, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: false }}
              className="flex rounded-lg w-full sm:w-[48vw] h-[300px] bg-pent overflow-hidden"
            >
              <Image
                src={project.image}
                alt={project.title}
                width={800} // Set appropriate width
                height={300} // Set appropriate height
                className="object-cover w-full h-full"
              />
            </motion.div>
          ))}
        </div>
        <div className="flex flex-col sm:flex-row gap-[2vw]">
          {projectData.projects.slice(2, 5).map((project, index) => (
            <motion.div
              key={index + 2} // Ensure unique keys
              initial={{ scale: 0.8, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: false }}
              className="flex rounded-lg w-full sm:w-[32vw] h-[300px] bg-pent overflow-hidden"
            >
              <Image
                src={project.image}
                alt={project.title}
                width={800} // Set appropriate width
                height={300} // Set appropriate height
                className="object-cover w-full h-full"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
